import { render, staticRenderFns } from "./auction-category-select.vue?vue&type=template&id=c84b0cc6&"
import script from "./auction-category-select.vue?vue&type=script&lang=js&"
export * from "./auction-category-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports